import WithRender from "../../templates/containers/pageOptionAttributesContainer.html";
import { mapActions, mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getActiveProductPageOptions",
      "getActivePageOptions",
      "getSecondPP",
      "getActiveProductPartCode",
      "getShouldTransferContentToCover",
      "getPPContentAttribute",
      "getChangeOptionsDataPPOpt"
    ]),
    getProductPageOptionValues: function () {
      var values = [];
      if (this.getActiveProductPageOptions[this.code]) {
        values = this.getActiveProductPageOptions[this.code].values;
      }

      if (this.code === "format" && this.getShouldTransferContentToCover) {
        if (
          "cover" == this.getPPContentAttribute(this.getActiveProductPartCode)
        ) {
          var contentProdPartCode = this.getSecondPP(
            this.getActiveProductPartCode
          );

          var contentFormatValue = this.getChangeOptionsDataPPOpt[
            "PP_" + contentProdPartCode
          ].format[0];

          for (var i = 0; i < values.length; i++) {
            if (values[i].value !== contentFormatValue) {
              values.splice(i, 1);
              i--;
            }
          }
        }
      }

      return values;
    },
    isSelect: function () {
      return ["pages", "format"].indexOf(this.getActivePageOptions) >= 0;
    },
    selectedValue: function () {
      if (this.getActiveProductPageOptions[this.code]) {
        const selected = this.getActiveProductPageOptions[this.code].selected;
        const defaultValue = this.getActiveProductPageOptions[this.code]
          .default_value;
        if (selected) return selected[0];
        if (defaultValue) return defaultValue[0];
        return null;
      }
    }
  },
  methods: {
    ...mapActions(["setPageOption", "moveToNextStep"]),
    handleOptionChange: function (e) {
      const value = e.target.value;
      this.setPageOption({ value: value, layout: true, optionType: "main" });
    },
    moveNext: function (e) {
      //this.setPageOption({   layout: true });
      let value;
      if (this.getActiveProductPageOptions[this.code]) {
        const selected = this.getActiveProductPageOptions[this.code].selected;
        const defaultValue = this.getActiveProductPageOptions[this.code]
          .default_value;
        if (selected) value = selected[0];
        else if (defaultValue) value = defaultValue[0];
      }
      this.moveToNextStep({ value: value, layout: true, optionType: "main" });
    }
  },
  props: ["propsData", "code", "hideContainer"]
});
